export const sideBarList = [
    {
        "lable":"Funds Management",
        "icon": "./assets/sideBar/dashboard.svg",
        "route":"/fundApplication"
    },
    {
        "lable":"Donation Tracker",
        "icon": "./assets/sideBar/home.svg",
        "route":"/donation"
    },
    {
        "lable":"Our Articles",
        "icon": "./assets/sideBar/addCategory.svg",
        "route":"/article",
    },
    {
        "lable":"Publisher Management",
        "icon": "./assets/sideBar/person.svg",
        "route":"/signup",
    },
]

export const exit={
    "lable":"Logout",
    "icon":"./assets/sideBar/logout.svg",
    "route":"/",
}

